// The activity card is `w-168` in ActivityDynamicLoaderModal, centred in the viewport.
export const ACTIVITY_CARD_WIDTH = 672

const MARGIN = 24
const MAX_WIDTH = 620
const MAX_HEIGHT = 600
// The docked panel is flush with the activity card rather than overlapping it: the card's close and
// hint-video buttons sit in its top-right corner, which is what any overlap would cover first. Below
// this width there is no room to dock and the panel goes back to the middle of the screen.
const DOCK_MIN_WIDTH = 320

export interface OracleLayout {
  x: number
  y: number
  width: number
  height: number
}

const centred = (viewportWidth: number, viewportHeight: number): OracleLayout => {
  const width = Math.min(930, viewportWidth - 60)
  const height = Math.min(550, viewportHeight - 60)

  return { x: (viewportWidth - width) / 2, y: (viewportHeight - height) / 2, width, height }
}

export function getDesktopOracleLayout({
  viewportWidth,
  viewportHeight,
  besideActivity,
}: {
  viewportWidth: number
  viewportHeight: number
  besideActivity: boolean
}): OracleLayout {
  if (!besideActivity) return centred(viewportWidth, viewportHeight)

  const activityRight = (viewportWidth + ACTIVITY_CARD_WIDTH) / 2
  const gutter = viewportWidth - activityRight - MARGIN

  if (gutter < DOCK_MIN_WIDTH) return centred(viewportWidth, viewportHeight)

  const width = Math.min(MAX_WIDTH, gutter)
  const height = Math.min(MAX_HEIGHT, viewportHeight - 2 * MARGIN)

  return { x: viewportWidth - width - MARGIN, y: (viewportHeight - height) / 2, width, height }
}

export const getOracleOpenTarget = (layout: OracleLayout): { x: number; y: number } => ({
  x: layout.x + layout.width / 2 - 110,
  y: layout.y + layout.height / 2 - 69,
})
